import React from 'react';
import pickBy from 'lodash.pickby';
import debounce from 'lodash.debounce';
import { Switch, Route } from 'react-router-dom';
import { Input } from 'reactstrap';

import MenuNav from './MenuNav';
import FullMenuList from './FullMenuList';
import SpecCardList from './SpecCardList';
import MenuHeader from './MenuHeader';
import ProductInfo from './ProductInfo';
import { menuSlug } from '../utils/menuSlug';

class Menu extends React.PureComponent {
  constructor(props) {
    super(props);

    const currentMeal = this.findCurrentMeal(props.meals);
    const categories = [...new Set(this.getCategories(currentMeal.fullMeal))];

    this.state = {
      searchTerm: '',
      search: '',
      meal: this.fillCategories(categories, currentMeal.fullMeal),
      fullMeal: currentMeal.fullMeal,
      current: currentMeal.current,
      selectedProduct: null,
    };
  }

  findCurrentMeal = meals => {
    const pathname = typeof window !== 'undefined' ? window.location.pathname : '';
    const mealNames = Object.keys(meals);

    for (let i = 0; i < mealNames.length; i += 1) {
      const current = mealNames[i].normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      if (pathname.indexOf(current) > -1) {
        return {
          current,
          fullMeal: Object.values(meals)[i],
        };
      }
    }

    return { current: '', fullMeal: [] };
  }

  getCategories = arrayOfObj => arrayOfObj.map(obj => obj.category);

  fillCategories = (categories, fromObj) => categories.reduce((groupedMeals, category) => {
    groupedMeals[category] = pickBy(fromObj, value => value.category.match(category));
    return groupedMeals;
  }, {});

  doSearch = debounce(() => {
    this.setState({ search: this.state.searchTerm });
  }, 300)

  handleSearch = event => {
    this.setState({ typeSearch: '' });
    this.setState({ searchTerm: event.target.value }, () => {
      this.doSearch();
    });
  }

  handleImageClick = meals => {
    this.setState({
      selectedProduct: {
        product: {
          title: meals.name,
          description: meals.body,
          ingredients: meals.contain.join(', '),
          price: meals.price,
        },
        category: meals.category,
        imageSrc: process.env.PUBLIC_URL + "/images/" + meals.picture + ".webp",
      },
    });
  }

  closeProductInfo = () => {
    this.setState({ selectedProduct: null });
  }

  render() {
    // let card = null;
    // let georgeYung = Object.keys(this.props.meals);
    // for(let i = 0; i< georgeYung.length; i++){
    //   let actual = georgeYung[i];
    //   debugger;
    //   if(window.location.href.indexOf(actual.normalize('NFD').replace(/[\u0300-\u036f]/g, "")) > -1) {
    //     debugger;
    //     card = Object.values(this.props.meals)[i];
    //   }
    // }


    const searchRE = new RegExp(this.state.search, 'i');
    let listedMeals;
    let searchMeals= {};
    if (this.state.search) {
      // pickBy is used to filter an object(instead of array), recives value and key(not used here)
      listedMeals = pickBy( this.state.fullMeal, (value) => {
        return value.name.match(searchRE)
          || value.body.match(searchRE)
          || value.contain.join(' ').match(searchRE);
      });
      let tempTypes= [...new Set(this.getCategories(Object
        .values(listedMeals)))];
      searchMeals = this.fillCategories(tempTypes, listedMeals);

    }

    const specCardList = () => {
      return(
        <SpecCardList
          listedMeals={this.state.meal}
          search={listedMeals}
          fullMeals={this.state.fullMeal}
          onImageClick={this.handleImageClick}
        />
      );
    };
    const fullList = () => {
      return(
        <FullMenuList
          meals={this.state.meal}
          search={searchMeals}
          searchTerm={this.state.search}
          onImageClick={this.handleImageClick}
        />
      );
    };
    return (
      <div>
        <MenuHeader current={this.state.current}/>
        <div className="">
            <Input
              type={"search"}
              placeholder={"Enter search term"}
              value={this.state.searchTerm}
              onChange={this.handleSearch}
              className={"float-left maR bg-grey search searchT"}
            />
            <MenuNav
              handleClick={this.handleClick}
              meal={this.state.meal}
              current={this.state.current}
            />
          <div className="clearfix"></div>
            <Switch>
              <Route exact path={process.env.PUBLIC_URL+'/'+this.state.current} component={fullList} />
              {Object.keys(this.state.meal).map((types, index) =>
                  <Route
                    key={types}
                    path={[
                      process.env.PUBLIC_URL+'/'+this.state.current+'/'+menuSlug(types),
                      process.env.PUBLIC_URL+'/'+this.state.current+'/'+types.normalize('NFD').replace(/[\u0300-\u036f]/g, ""),
                    ]}
                    component={specCardList}
                    />
                )
              }
            </Switch>

        </div>
        {this.state.selectedProduct && (
          <ProductInfo
            product={this.state.selectedProduct.product}
            categoryLabel={this.state.selectedProduct.category}
            imageSrc={this.state.selectedProduct.imageSrc}
            labels={{
              close: 'Close product details',
              ingredients: 'Ingredients',
            }}
            onClose={this.closeProductInfo}
          />
        )}
      </div>
    );
  }
}

export default Menu;
